import settings from '@/settings';
import { getShortenCountryName } from '@/lib/use-origin-country';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { REDIRECT_HOME } from '@/lib/common';
import warrantyRefunds from '@/settings/policies/warranty-refunds';

export const getServerSideProps = async () => {
  if (!warrantyRefunds) {
    return REDIRECT_HOME;
  }

  return { props: {} };
};

export default function RefundPolicy() {
  if (!warrantyRefunds) {
    return null;
  }

  const country = getShortenCountryName();
  const localizedMeta: Partial<
    Record<typeof settings.store, { title: string; description: string }>
  > = {
    'reebelo-fr': {
      title: `Garantie et remboursements - Reebelo ${country}`,
      description: `Consultez la politique de garantie et de remboursement de Reebelo ${settings.country} : retours, garanties légales et couverture ReebeloCare.`,
    },
    'reebelo-es': {
      title: `Garantía y reembolsos - Reebelo ${country}`,
      description: `Consulta la política de garantía y reembolso de Reebelo ${settings.country}: devoluciones, garantías legales y cobertura ReebeloCare.`,
    },
    'reebelo-it': {
      title: `Garanzia e rimborsi - Reebelo ${country}`,
      description: `Consulta la politica di garanzia e rimborso di Reebelo ${settings.country}: resi, garanzie di legge e copertura ReebeloCare.`,
    },
    'reebelo-se': {
      title: `Garanti och återbetalningar - Reebelo ${country}`,
      description: `Läs garanti- och returpolicyn för Reebelo ${country}: returer, lagstadgade rättigheter och ReebeloCare-skydd.`,
    },
    'reebelo-nl': {
      title: `Garantie en retourneren - Reebelo ${country}`,
      description: `Bekijk het garantie- en retourbeleid van Reebelo ${settings.country}: gratis retourneren, garantie en gedeeltelijke terugbetalingen.`,
    },
  };
  const meta = localizedMeta[settings.store] ?? {
    title: `Warranty & Refund Policy - Reebelo ${country}`,
    description: `Reebelo ${settings.country} is APAC’s leading marketplace for sustainable tech with offices in ${settings.country_office_locations}. The positive customer experience at Reebelo ${settings.country} is of utmost importance to us. Please check here for Reebelo ${settings.country} Warranty & Refund policies.`,
  };

  return (
    <>
      <WebsiteSchema title={meta.title} description={meta.description} />
      <div className="reebelo-container max-w-[800px] py-8">
        <div
          //  eslint-disable-next-line tailwindcss/no-custom-classname
          className="policies-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: warrantyRefunds }}
        ></div>
      </div>
    </>
  );
}
